var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{attrs:{"img-src":_vm.unit.thumbnail == '/img/no-img.jpg' ? 'https://res.cloudinary.com/transplan/image/upload/v1598353187/no-img_tumjza.jpg' : _vm.unit.thumbnail,"img-width":120,"title":_vm.unit.adres,"sub-title":_vm.unit.wijk_plaats,"img-fluid":"","img-left":""}},[_vm._v("\n  "+_vm._s(_vm.unit.unitkenmerk)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }